export enum AudioStatus{
  PLAYING,
  LOADING,
  PAUSED,
  ENDED
}
